export default __webpack_public_path__ + "static/530-675bbd428d834268123ab5fd21f387f0.gif";